export { default as useOnClickOutside } from './useOnClickOutside';
export * from './useOnClickOutside';
//# sourceMappingURL=index.js.map